import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { GridOptions } from 'ag-grid';
import { CoachService } from '../services/coach/CoachService';
import { Globals } from '../globals';
import { isUndefined } from 'util';
import { AssignAssesmentsNewModalComponent } from '../coach/assign-assesments-new-modal/assign-assesments-new-modal.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-assign-assessment-modal',
  templateUrl: './assign-assessment-modal.component.html',
  styleUrls: ['./assign-assessment-modal.component.scss']
})
export class AssignAssessmentModalComponent implements OnInit {

    @ViewChild('assignAssessment', {static: false}) public modal: ModalDirective;
    @ViewChild('assignAssessmentNew', {static: false}) public assignAssessmentNewModal: AssignAssesmentsNewModalComponent;

    //@ViewChild('modalContent') modalContent: ElementRef;
    assessmentsELIData: any[] = [];
    assessments360Data: any[] = [];
    assessmentsRegularGridApi: any;
    assessments360GridApi: any;
    assessmentsHeaders: any[] = [];
    selectedAssessment: any[] = [];
    assessmentsGridOptions: GridOptions;
    currentAssessmentTypeSelected: number;
    modalIndex: number;
    parent: any;

    constructor(
        private _CoachService: CoachService,
        private _Globals: Globals,
        private _toastr: ToastrService
    ) { }

    ngOnInit() {
        this.assessmentsGridOptions = <GridOptions>{};
        this.assessmentsGridOptions.rowHeight = 45;
        this.assessmentsGridOptions.headerHeight = 40;

        this.assessmentsHeaders = this.createAssessmentsHeaders();
        //this.assignAssessmentNewModal.ngOnInit();
    }

    show(): void {
        this.modal.show();
    }

    onShown(): void {
    }

    close(): void {
        this.modal.hide();
    }

    showAssignModal(parent: any, type: number) {
        this.parent = parent;
        this.currentAssessmentTypeSelected = type;
        this.getCoachAvailableAssessmentsByType(1);
        this.getCoachAvailableAssessmentsByType(2);

        this.show();

        $('#manageTab2').removeClass('active in');
        $('#manageTab1').addClass('active in');
        $('.manageAssessmentTabs #assessmentTypes li').removeClass('active');
        $('.manageAssessmentTabs #assessmentTypes li').eq(0).addClass('active');
        this.sizeToFit(this.assessmentsRegularGridApi);
    }

    getSelectedRows(gridApi): any {
        console.log("SELECTED", gridApi.getSelectedRows());
        return gridApi.getSelectedRows();
    }

    onAssessmentsSelectionChanged(grid, event) {

        console.log("onSelectionChanged ", event);

        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (grid === 1) {
            this.selectedAssessment = this.getSelectedRows(this.assessmentsRegularGridApi);
        } else {
            this.selectedAssessment = this.getSelectedRows(this.assessments360GridApi);
        }

        console.log("selected Assessment", this.selectedAssessment);
    }

    getCoachAvailableAssessmentsByType(assessmentType: number) {
        this._CoachService.getCoachAvailableAssessmentsByType(assessmentType).subscribe((data: any) => {
            console.log('response_getCoachAvailableAssessmentsByType', data);
            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);

                if (assessmentType === 1) {
                    this.assessmentsELIData = _data;
                } else {
                    this.assessments360Data = _data;
                }

            }

        });
    }

    selectedTab(index: number) {
        console.log(index);
        switch (index) {
            case 1:
                this.sizeToFit(this.assessmentsRegularGridApi);
                this.deselectAllCheckBox(this.assessments360GridApi);
                break;
            case 2:
                this.sizeToFit(this.assessments360GridApi);
                this.deselectAllCheckBox(this.assessmentsRegularGridApi);
                break;
        }
    }

    deselectAllCheckBox(gridApi: any) {
        gridApi.forEachNode(function (node) {
            node.setSelected(false);
        });
    }

    sizeToFit(gridApi: any) {
        gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    assignOnGridReady(grid, params) {
        if (grid === 1) {
            this.assessmentsRegularGridApi = params.api;
        } else {
            this.assessments360GridApi = params.api;
        }
    }

    onAssessessmentRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;
        }
    }

    createAssessmentsHeaders() {
        let columnDefs = new Array();

        let nameHeader = {
            headerName: 'Name',
            field: 'AssessmentName',
            checkboxSelection: true,
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(nameHeader);

        let quantityHeader = {
            headerName: 'Quantity',
            field: 'Amount',
            minWidth: 120,
            width: 120,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(quantityHeader);

        return columnDefs;
    }

    openAssignModal() {
        console.log(this.selectedAssessment);
        let data = this.selectedAssessment[0];

        if (!isUndefined(data)) {
            this._Globals.closeHomeAssignModal = true;
            this.modalIndex = 1;
            this.assignAssessmentNewModal.show(this, false, data.Is360, data.Amount, data.AssessmentName, data.AssessmentId, undefined);
        } else {
            this._toastr.warning('Please select one assessment to assign.', 'ELI');
        }

    }


}
